import fetchSuGRStreets from '@/helpers/fetchSuGRStreets';
import { QueryObserverOptions, useQuery } from 'react-query';

export type CityData = {
  city: string;
  zipCode: string;
};

const fetchStreets =
  (cityData: CityData | undefined, searchTerm: string) => async () => {
    if (!cityData) {
      throw new Error('Missing cityData');
    }

    const streets = await fetchSuGRStreets({
      zipCode: cityData.zipCode,
      city: cityData.city,
      limit: 5,
      term: searchTerm,
    });

    if (!streets) {
      throw new Error(
        'Failed to fetch street suggestions for the provided city data'
      );
    }

    return streets;
  };

const useSuGRStreets = (
  searchTerm = '',
  cityData: CityData | undefined,
  queryConfig: QueryObserverOptions<string[]> = {}
) => {
  return useQuery<string[]>(
    ['streetSuggestions', cityData?.zipCode, cityData?.city, searchTerm],
    fetchStreets(cityData, searchTerm),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      staleTime: Infinity,
      retry: 1,
      enabled: searchTerm.length > 2 && !!cityData?.city && !!cityData?.zipCode,
      ...queryConfig,
    }
  );
};

export default useSuGRStreets;
